// Array.from splits by code point, so it breaks up flag and ZWJ emoji; it only
// runs where Intl.Segmenter is missing (Firefox < 125).
let segmenter: Intl.Segmenter | null | undefined;
function firstGrapheme(text: string): string | undefined {
  if (segmenter === undefined) {
    segmenter =
      typeof Intl !== "undefined" && "Segmenter" in Intl
        ? new Intl.Segmenter(undefined, { granularity: "grapheme" })
        : null;
  }
  if (segmenter) {
    return segmenter.segment(text)[Symbol.iterator]().next().value?.segment;
  }
  return Array.from(text)[0];
}

export function buildFullName(
  givenName?: string,
  familyName?: string
): string | undefined {
  let fullName;
  if (givenName) {
    fullName = givenName;
  }
  if (familyName) {
    if (fullName) {
      fullName += " " + familyName;
    } else {
      fullName = familyName;
    }
  }
  return fullName;
}
export function buildShortName({
  givenName,
  familyName,
}: {
  givenName?: string | null;
  familyName?: string | null;
}) {
  let shortName = givenName || "";

  if (familyName) {
    const initial = firstGrapheme(familyName);
    if (initial) {
      if (shortName.length > 0) {
        shortName += " ";
      }
      shortName += initial;
    }
  }
  return shortName;
}
export function buildCoachName(givenName: string) {
  return `Coach ${givenName}`;
}
